function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.2371 13.6518C12.1219 13.6518 13.6499 12.1239 13.6499 10.239C13.6499 8.35415 12.1219 6.82617 10.2371 6.82617C8.3522 6.82617 6.82422 8.35415 6.82422 10.239C6.82422 12.1239 8.3522 13.6518 10.2371 13.6518Z",
  fill: "#19BCFE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41284 20.477C4.31798 20.477 5.18605 20.1175 5.82608 19.4774C6.46611 18.8374 6.82568 17.9693 6.82568 17.0642V13.6514H3.41284C2.5077 13.6514 1.63963 14.0109 0.999597 14.651C0.359566 15.291 0 16.1591 0 17.0642C0 17.9693 0.359566 18.8374 0.999597 19.4774C1.63963 20.1175 2.5077 20.477 3.41284 20.477Z",
  fill: "#09CF83"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41284 13.6518H6.82568V6.82617H3.41284C2.5077 6.82617 1.63963 7.18574 0.999597 7.82577C0.359566 8.4658 0 9.33387 0 10.239C0 11.1442 0.359566 12.0122 0.999597 12.6523C1.63963 13.2923 2.5077 13.6518 3.41284 13.6518Z",
  fill: "#A259FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41284 6.82568H6.82568V0H3.41284C2.5077 0 1.63963 0.359566 0.999597 0.999597C0.359566 1.63963 0 2.5077 0 3.41284C0 4.31798 0.359566 5.18605 0.999597 5.82608C1.63963 6.46611 2.5077 6.82568 3.41284 6.82568Z",
  fill: "#F24E1E"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2371 6.82568H6.82422V0H10.2371C11.1422 0 12.0103 0.359566 12.6503 0.999597C13.2903 1.63963 13.6499 2.5077 13.6499 3.41284C13.6499 4.31798 13.2903 5.18605 12.6503 5.82608C12.0103 6.46611 11.1422 6.82568 10.2371 6.82568Z",
  fill: "#FF7262"
});

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figma.ee1edf20.svg";
export { ForwardRef as ReactComponent };